import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import {
  getAttentionStatusRole,
  type TAttentionStatusActionId,
} from 'partner360/entities/attentionStatuses'

import { getAttentionRemindersHiddenByItems } from '../../../lib'
import { selectCockpitUserAccess } from '../../../model/selectors'

interface IOwnerItemCounts {
  /** The reader's own items, which are the PBM's for a PBM and the manager's for a manager. */
  mine: number
  pbm: number
  manager: number
}

/** The reminders a status hides for the reader by whose items are open (H2 review, pending actions). */
export const useAttentionRemindersHiddenByItems = (
  bitValue: number,
  { mine, pbm, manager }: IOwnerItemCounts
): TAttentionStatusActionId[] => {
  const { role } = useSelector(selectCockpitUserAccess)
  const statusRole = getAttentionStatusRole(role)

  return useMemo(
    () =>
      getAttentionRemindersHiddenByItems(bitValue, statusRole, {
        pbmItems: pbm + (statusRole === 'pbm' ? mine : 0),
        managerItems: manager + (statusRole === 'manager' ? mine : 0),
      }),
    [bitValue, manager, mine, pbm, statusRole]
  )
}
